<div class="onboarding-preview-wrap" [class.is-flipped]="step === 2">
  <!-- The rotating card -->
  <div class="onboarding-preview">
    <!-- FRONT face (Step 1) -->
    <div class="onboarding-preview__face onboarding-preview__face--front">
      <!-- Step 1 content -->
      <app-user-image
        class="onboarding-preview__photo"
        [user]="user"
        [size]="128"
      ></app-user-image>

      @if (profileForm && profileForm.value.firstname.length > 0) {
        <h1 class="onboarding-preview__name">{{ profileForm.value.firstname }}</h1>
      } @else {
        <div class="onboarding-preview__name skeleton-loading"></div>
      }

      <div class="onboarding-preview__biography">
        @if (profileForm && profileForm.value.biography.length > 0) {
          <p>{{ profileForm.value.biography }}</p>
        } @else {
          <div class="skeleton-loading"></div>
          <div class="skeleton-loading"></div>
          <div class="skeleton-loading"></div>
        }
      </div>

      <div class="onboarding-preview__location">
        <i class="fa-solid fa-location-dot"></i>
        @if (profileForm && profileForm.value.city && profileForm.value.city.length > 0) {
          <p>{{ profileForm.value.city }}</p>
        } @else {
          <div class="skeleton-loading"></div>
        }
      </div>

      <div class="onboarding-preview__tags">
        @if (profileForm && profileForm.value.tags.length > 0) {
          @for (tag of profileForm.value.tags; track tag) {
            <div class="onboarding-preview__tags-tag">
              <p>{{ getTagIconFromLabel(tag) }}</p>
              <p>{{ ('marketplace.photographer.tags.' + tag) | transloco }}</p>
            </div>
          }
        } @else {
          <div class="onboarding-preview__tags-tag skeleton-loading"></div>
          <div class="onboarding-preview__tags-tag skeleton-loading"></div>
          <div class="onboarding-preview__tags-tag skeleton-loading"></div>
          <div class="onboarding-preview__tags-tag skeleton-loading"></div>
          <div class="onboarding-preview__tags-tag skeleton-loading"></div>
        }
      </div>

      <div class="onboarding-preview__filler">
        <div class="filler--line skeleton-loading"></div>
        <div class="filler--line skeleton-loading"></div>
        <div class="filler--line skeleton-loading"></div>
        <div class="filler--line skeleton-loading"></div>
        <div class="filler--line skeleton-loading"></div>
        <div class="filler--line skeleton-loading"></div>
        <div class="filler--line skeleton-loading"></div>
        <div class="filler--line skeleton-loading"></div>
        <div class="filler--line skeleton-loading"></div>
        <div class="filler--line skeleton-loading"></div>
      </div>
    </div>

    <!-- BACK face (Step 2) -->
    <div class="onboarding-preview__face onboarding-preview__face--back">
      <!-- Step 2 content (unchanged) -->
      <h2>{{ 'onboarding.services.title' | transloco }}</h2>

      <div class="onboarding-preview__service">
        @if (serviceImageUrl) {
          <div class="onboarding-preview__service-image">
            <img
              [src]="serviceImageUrl"
              [alt]="serviceForm?.value.serviceName || 'Service image'"
              loading="lazy"
            />
          </div>
        } @else {
          <div class="onboarding-preview__service-image skeleton-loading"></div>
        }

        <div class="onboarding-preview__service-info">
          @if (serviceForm && serviceForm.value.serviceName.length > 0) {
            <h3 class="onboarding-preview__service-info-name">{{ serviceForm.value.serviceName }}</h3>
          } @else {
            <div class="onboarding-preview__service-info-name skeleton-loading"></div>
          }
          @if (serviceForm && serviceForm.value.servicePrice) {
            <p class="onboarding-preview__service-info-price">
              {{ serviceForm.value.servicePrice | currency: 'EUR' }}
            </p>
          } @else {
            <div class="onboarding-preview__service-info-price skeleton-loading"></div>
          }
          @if (serviceForm && serviceForm.value.serviceDescription.length > 0) {
            <p class="onboarding-preview__service-info-description">{{ serviceForm.value.serviceDescription }}</p>
          } @else {
            <div class="onboarding-preview__service-info-description skeleton-loading"></div>
          }
        </div>
      </div>

      <div class="onboarding-preview__service-filler">
        <div class="onboarding-preview__service">
          <div class="onboarding-preview__service-image skeleton-loading"></div>
          <div class="onboarding-preview__service-info">
            <div class="onboarding-preview__service-info-name skeleton-loading"></div>
            <div class="onboarding-preview__service-info-price skeleton-loading"></div>
            <div class="onboarding-preview__service-info-description skeleton-loading"></div>
          </div>
        </div>
        <div class="onboarding-preview__service">
          <div class="onboarding-preview__service-image skeleton-loading"></div>
          <div class="onboarding-preview__service-info">
            <div class="onboarding-preview__service-info-name skeleton-loading"></div>
            <div class="onboarding-preview__service-info-price skeleton-loading"></div>
            <div class="onboarding-preview__service-info-description skeleton-loading"></div>
          </div>
        </div>
        <div class="onboarding-preview__service">
          <div class="onboarding-preview__service-image skeleton-loading"></div>
          <div class="onboarding-preview__service-info">
            <div class="onboarding-preview__service-info-name skeleton-loading"></div>
            <div class="onboarding-preview__service-info-price skeleton-loading"></div>
            <div class="onboarding-preview__service-info-description skeleton-loading"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
